import React, { Component } from 'react'
import { Popup, Tabs, ScrollView } from 'devextreme-react'
import FormDataInformasiPribadi from './informasiPribadi'
import FormDocument from './dataDokumen'
import InformasiKeluarga from './informasiKeluarga'
import notify from 'devextreme/ui/notify'
import { formatDate } from 'plugin/helper'
import httpRequest from 'plugin/httprequest'
import { showLoading } from 'redux/actions/loading'
import { confirm } from 'devextreme/ui/dialog';

class ModalPesertaAktif extends Component {
  constructor(props) {
    super(props)

    this.state = {
      popupVisible: false,
      dataMaster: {},
      dataDocument: [],
      selectedTabIndex: 0,
    }

    this.show = this.show.bind(this)
    this.hide = this.hide.bind(this)

    this.popupRef = React.createRef()
    this.informasiKeluargaRef = React.createRef()
    this.informasiPribadiRef = React.createRef()
    this.profileResikoRef = React.createRef()
    this.informasiDokumenRef = React.createRef()

    this.prevTabIndex = 0

    this.popupToolbarItem = [
      {
        widget: 'dxButton',
        location: 'after',
        options: {
          text: 'Simpan',
          elementAttr: { class: 'bg-button-popup-save-dapen-default' },
          onClick: async() => {
            let result = await confirm('Apakah anda yakin mengirim data ini ?','Konfirmasi')
            if(result){  
              await this.submitData()
            }
          },
        },
        toolbar: 'bottom',
      },
      {
        widget: 'dxButton',
        location: 'after',
        options: {
          text: 'Batal',
          elementAttr: { class: 'bg-button-popup-close-dapen-default' },
          onClick: () => {
            this.hide()
          },
        },
        toolbar: 'bottom',
      },
    ]

    this.popupToolbarItemEdit = [
      {
        widget: 'dxButton',
        location: 'after',
        options: {
          text: 'Batal',
          elementAttr: { class: 'bg-button-popup-close-dapen-default' },
          onClick: () => {
            this.hide()
          },
        },
        toolbar: 'bottom',
      },
    ]

    this.TabDataSource = [
      {
        id: 0,
        text: 'Informasi Pribadi',
      },
      {
        id: 1,
        text: 'Informasi Keluarga',
      },
      {
        id: 2,
        text: 'Data Dokumen',
      },
    ]
  }
  get Popup() {
    return this.popupRef.current.instance
  }

  show() {
    this.setState({
      popupVisible: true,
    })
  }

  hide() {
    if (this.informasiPribadiRef.current) {
      this.informasiPribadiRef.current.removeState()
    }
    if (this.informasiKeluargaRef.current) {
      this.informasiKeluargaRef.current.removeState()
    }
    if (this.informasiDokumenRef.current) {
      this.informasiDokumenRef.current.removeState()
    }

    this.setState({
      popupVisible: false,
      dataMaster: {},
      dataDocument: [],
    })
  }

  onTabSelectionChanged = (args) => {
    if (args.name === 'selectedIndex' && args.value !== -1) {
      this.setState({
        selectedTabIndex: args.value,
      })
    }
  }

  retrieveData = async (data) => {
    if (data) {
      data.alamat12 = data.alamat12 ? parseInt(data.alamat12) : null
      data.alamat13 = data.alamat13 ? parseInt(data.alamat13) : null
      data.alamat22 = data.alamat22 ? parseInt(data.alamat22) : null
      data.alamat23 = data.alamat23 ? parseInt(data.alamat23) : null
      const getDokumen = await httpRequest(
        process.env.REACT_APP_BACKEND_CORE,
        this.props.store,
        `dokumen-participant-pesertas/pesertaId/${data.id}`,
        'GET'
      )

      this.informasiPribadiRef.current.retrieveData(data)
      this.informasiKeluargaRef.current.retrieveData(data)
      this.informasiDokumenRef.current.retrieveData(getDokumen)
    }
  }

  submitData = async () => {
    let dataPribadi = this.informasiPribadiRef.current.sendData()
    let dataKeluarga = this.informasiKeluargaRef.current.sendData()
    let dataDokumen = this.informasiDokumenRef.current.sendData()

    this.props.store.dispatch(showLoading(true))
    try {
      const param = {
        ...dataPribadi,
        statusId: 1,
        tanggalLahir: formatDate(dataPribadi.tanggalLahir),
        tanggalMasaKerja: formatDate(dataPribadi.tanggalMasaKerja),
        ...dataKeluarga,
        tanggalLahirAnak1: dataKeluarga.tanggalLahirAnak1
          ? formatDate(dataKeluarga.tanggalLahirAnak1)
          : null,
        tanggalLahirAnak2: dataKeluarga.tanggalLahirAnak2
          ? formatDate(dataKeluarga.tanggalLahirAnak2)
          : null,
        tanggalLahirAnak3: dataKeluarga.tanggalLahirAnak3
          ? formatDate(dataKeluarga.tanggalLahirAnak3)
          : null,
        tanggalLahirPasangan: dataKeluarga.tanggalLahirPasangan
          ? formatDate(dataKeluarga.tanggalLahirPasangan)
          : null,
        participantId: this.props.store.getState().sessionUser
          ? this.props.store.getState().sessionUser.participantId
          : 0,
        dokumenPeserta: dataDokumen,
      }

      await httpRequest(
        process.env.REACT_APP_BACKEND_CORE,
        this.props.store,
        'manual-peserta-participant',
        'POST',
        {
          values: param,
        }
      )

      this.hide()
      this.props.store.dispatch(showLoading(false))
      notify(
        {
          message: 'Berhasil Simpan Data!',
          width: 'AUTO',
          shading: true,
          position: { at: 'center', my: 'center', of: window },
        },
        'success',
        1000
      )
      this.props.forceRefresh()
    } catch (e) {
      console.log(e)
      this.props.store.dispatch(showLoading(false))
      notify(
        {
          message: 'Gagal Simpan Data',
          width: 'AUTO',
          shading: true,
          position: { at: 'center', my: 'center', of: window },
        },
        'error',
        1000
      )
    }
  }

  renderElement = () => {
    return (
      <>
        <div className="row">
          <div className="col-md-12">
            <Tabs
              dataSource={this.TabDataSource}
              selectedIndex={this.state.selectedTabIndex}
              onOptionChanged={this.onTabSelectionChanged}
            />
          </div>
        </div>
        <ScrollView width="100%" height="100%">
          <div
            id={`tabIndexModalDetil-0`}
            className={
              (this.state.selectedTabIndex !== 0 ? 'd-none' : '') +
              ' mt-2 col-md-12'
            }
            style={{ minHeight: 'calc(30vh)' }}
          >
            <FormDataInformasiPribadi
              store={this.props.store}
              ref={this.informasiPribadiRef}
              actionType={this.props.actionType}
            />
          </div>
          <div
            id={`tabIndexModalDetil-1`}
            className={
              (this.state.selectedTabIndex !== 1 ? 'd-none' : '') +
              ' mt-2 col-md-12'
            }
            style={{ minHeight: 'calc(30vh)' }}
          >
            <InformasiKeluarga
              store={this.props.store}
              ref={this.informasiKeluargaRef}
              actionType={this.props.actionType}
            />
          </div>
          <div
            id={`tabIndexModalDetil-2`}
            className={
              (this.state.selectedTabIndex !== 2 ? 'd-none' : '') +
              ' mt-2 col-md-12'
            }
            style={{ minHeight: 'calc(30vh)' }}
          >
            <FormDocument
              store={this.props.store}
              ref={this.informasiDokumenRef}
              actionType={this.props.actionType}
            />
          </div>
        </ScrollView>
      </>
    )
  }

  render() {
    let elem = this.state.popupVisible && this.renderElement()
    return (
      <Popup
        className={'popup'}
        visible={this.state.popupVisible}
        onHiding={this.hide}
        dragEnabled={true}
        resizeEnabled={true}
        showTitle={true}
        title={'Form Registrasi Peserta'}
        width={'70vw'}
        height={'70vh'}
        ref={this.popupRef}
        toolbarItems={
          this.props.actionType === 'add'
            ? this.popupToolbarItem
            : this.popupToolbarItemEdit
        }
      >
        <div
          className="container-fluid"
          style={{ height: 'calc(70vh - 155px)' }}
        >
          {elem}
        </div>
      </Popup>
    )
  }
}

export default ModalPesertaAktif
